import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ContactIslands from '@/components/ContactIslands';
import LeadPopup from '@/components/LeadPopup';
import Home from '@/pages/Home';
import Overview from '@/pages/Overview';
import ConfigPage from '@/pages/ConfigPage';
import FloorPlans from '@/pages/FloorPlans';
import Amenities from '@/pages/Amenities';
import LocationPage from '@/pages/Location';
import Gallery from '@/pages/Gallery';
import Rera from '@/pages/Rera';
import Faqs from '@/pages/Faqs';
import Contact from '@/pages/Contact';
import SeoPage from '@/pages/SeoPage';
import Legal from '@/pages/Legal';
import Admin from '@/pages/Admin';
import NotFound from '@/pages/NotFound';
import { initSession, initAnalytics } from '@/lib/tracking';

let lenisInstance = null;

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    initSession();
    initAnalytics();
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/1-bhk" element={<ConfigPage configKey="1-bhk" />} />
            <Route path="/2-bhk" element={<ConfigPage configKey="2-bhk" />} />
            <Route path="/2-5-bhk" element={<ConfigPage configKey="2-5-bhk" />} />
            <Route path="/provident-palm-vista-floor-plan" element={<FloorPlans />} />
            <Route path="/provident-palm-vista-amenities" element={<Amenities />} />
            <Route path="/provident-palm-vista-location" element={<LocationPage />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/provident-palm-vista-rera" element={<Rera />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/provident-palm-vista-price" element={<SeoPage pageKey="/provident-palm-vista-price" />} />
            <Route path="/provident-palm-vista-brochure" element={<SeoPage pageKey="/provident-palm-vista-brochure" />} />
            <Route path="/provident-palm-vista-reviews" element={<SeoPage pageKey="/provident-palm-vista-reviews" />} />
            <Route path="/flats-in-shilphata" element={<SeoPage pageKey="/flats-in-shilphata" />} />
            <Route path="/1-bhk-flats-in-shilphata" element={<SeoPage pageKey="/1-bhk-flats-in-shilphata" />} />
            <Route path="/2-bhk-flats-in-shilphata" element={<SeoPage pageKey="/2-bhk-flats-in-shilphata" />} />
            <Route path="/property-in-shilphata" element={<SeoPage pageKey="/property-in-shilphata" />} />
            <Route path="/flats-kalyan-shilphata-road" element={<SeoPage pageKey="/flats-kalyan-shilphata-road" />} />
            <Route path="/privacy-policy" element={<Legal pageKey="/privacy-policy" />} />
            <Route path="/terms-conditions" element={<Legal pageKey="/terms-conditions" />} />
            <Route path="/disclaimer" element={<Legal pageKey="/disclaimer" />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <ContactIslands />
        <LeadPopup />
      </BrowserRouter>
    </div>
  );
}

export default App;
